module.exports = __webpack_public_path__ + "media/images/plans/schedule_5-3a1360c48dd11f39904eaeb91c9891ba.jpg";